import { Colors } from "@/enums/Colors";
import DoneIcon from "@mui/icons-material/Done";
import { Box, Typography, styled } from "@mui/material";

interface HeaderOnBoardingComponentProps {
  step: 0 | 1 | 2;
}
const HeaderOnBoardingComponent = ({ step }: HeaderOnBoardingComponentProps) => {
  const getBoxStyle = (current: number) => {
    const active = current === step;
    return {
      borderBottom: `solid 1.5px ${active ? Colors.BUTTON_HOVER_PURPLE : Colors.LIGHT_GRAY_8A8E93}`,
      color: active ? Colors.BLACK_151517 : Colors.LIGHT_GRAY_8A8E93,
    };
  };

  const getIsDone = (current: number) => {
    if ((step === 2 && current !== 2) || (step === 1 && current === 0)) {
      return <DoneIcon style={{ color: Colors.ACCENT_GREEN_01A902 }} />;
    } else {
      return null;
    }
  };

  return (
    <Container>
      <StepTitleContainer sx={getBoxStyle(0)}>
        <StyledTypography>1. Personal {getIsDone(0)}</StyledTypography>
      </StepTitleContainer>
      <StepTitleContainer sx={getBoxStyle(1)}>
        <StyledTypography>2. Company {getIsDone(1)}</StyledTypography>
      </StepTitleContainer>
      <StepTitleContainer sx={getBoxStyle(2)}>
        <StyledTypography>3. Activity {getIsDone(2)}</StyledTypography>
      </StepTitleContainer>
    </Container>
  );
};

const Container = styled(Box)(({ theme }) => ({
  width: "70%",
  marginTop: "16px",
  display: "flex",
  justifyContent: "space-between",
  gap: "8px",
  [theme.breakpoints.down("md")]: {
    width: "95%",
    marginTop: 0,
  },
}));

const StyledTypography = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: "14px",
  lineHeight: "20px",
  textAlign: "center",
  display: "flex",
  justifyContent: "center",
  gap: "8px",
  [theme.breakpoints.down("md")]: {
    fontSize: "12px",
    lineHeight: "18px",
  },
}));

const StepTitleContainer = styled(Box)(({ theme }) => ({
  width: "172px",
  height: "44px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  [theme.breakpoints.down("md")]: {
    width: "109px",
    height: "42px",
  },
}));
export default HeaderOnBoardingComponent;
